/**
 * @module components\ghTable\vuetifyTable\vuetifyRow\vuetifyCell\template\cellImage
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "../../base";
import { API_BASE_URL } from "@/utils/conf";
@Component
export default class CellImage extends Base {
  private get Source() {
    let s = API_BASE_URL + this.prop.source;
    try {
      let value = eval("this.model." + this.prop.value);
      if (value) {
        return s + "/" + value;
      } else {
        return "";
      }
    } catch (error) {
      return "";
    }
  }
}
